import { Badge, Paper, Text, Title } from '@mantine/core';
import { Button } from '../Button/Button';
import classes from './ToolCard.module.css';
import { Wrapper } from './ToolCard.style';

export type ToolCardProps = {
  item: Json;
};

export function ToolCard(props: ToolCardProps) {
  const { item } = props;
  const { title, category, personas } = item;

  function renderBadge(item: string) {
    return (
      <Badge key={item} className={classes.badge} color='#11998e'>
        {item}
      </Badge>
    );
  }

  function renderBadges() {
    return personas.map((item: string) => renderBadge(item));
  }

  return (
    <Wrapper className='ToolCard-wrapper' data-testid='ToolCard-wrapper'>
      <Paper shadow='md' p='xl' radius='md' className={classes.card}>
        <div className={classes.top}>
          <Text className={classes.category} size='xs'>
            {category}
          </Text>
          <Title order={3} className={classes.title}>
            {title}
          </Title>
          <br />
          {renderBadges()}
        </div>
        <Button
          variant='gradient'
          radius='xl'
          gradient={{ from: '#11998e', to: '#38ef7d' }}
          className={classes.cta}
        >
          Try tool
        </Button>
      </Paper>
    </Wrapper>
  );
}

export default ToolCard;
